import platform from 'components/Trackers/platform'
import { useTracking } from 'utils/analytics/useTracking'

export const useCardOrderReviewTracking = () => {
  const track = useTracking(screenViewed)

  return {
    confirmTapped: () => track.buttonTapped(confirmTapped),
    timeoutContainerViewed: () => track.containerViewed(timeoutErrorContainerViewed),
    timeoutButtonTapped: () => track.buttonTapped(timeoutErrorButtonTapped),
  }
}

export const useCardOrderReviewErrorTracking = () => {
  const track = useTracking(errorAlertViewed)

  return {
    doneTapped: () => track.buttonTapped(errorAlertDoneTapped),
  }
}

const sharedProps = {
  platform,
  card_type: 'moc',
  context: 'registration',
  screen: 'registrationSpendOrder',
  screen_name: 'registrationSpendOrder',
}

const screenViewed = {
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationSpendOrder',
  ...sharedProps,
}

const confirmTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendOrderConfirm',
  ...sharedProps,
}

const errorAlertViewed = {
  object: 'Screen',
  action: 'Viewed',
  object_name: 'spendVerificationAlert',
  ...sharedProps,
}

const errorAlertDoneTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'spendVerificationAlertDone',
  ...sharedProps,
}

const timeoutErrorContainerViewed = {
  object: 'Container',
  action: 'Viewed',
  object_name: 'spendVerificationTimeoutError',
  ...sharedProps,
}

const timeoutErrorButtonTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'spendVerificationTimeoutErrorDismiss',
  ...sharedProps,
}
